const dev = {
    endpoints: {
        passwordResetSendInvite: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordResetSendInvite",
        passwordResetValidateInvite: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordResetValidateInvite",
        passwordReset: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordReset",
    }
};

const prd = {
    endpoints: {
        passwordResetSendInvite: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordResetSendInvite",
        passwordResetValidateInvite: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordResetValidateInvite",
        passwordReset: "https://4949x870wd.execute-api.us-west-2.amazonaws.com/prd/passwordReset",
    }
};

const configMap = {
    'prd': prd,
    'dev': dev,
};

const config = configMap[process.env.REACT_APP_STAGE];

export const endpoints = config.endpoints;
